import * as React from 'react';
import {isDesktop, isIOS, isAndroid} from 'react-device-detect';

export const typ: number = 2;      // 1 -dev, 2 - prod, 3 - stage
export const AppVersion = '1.1.56';
export const AppData = '202610091440';

export const HOST = () => {
    switch (typ) {
        case 1:
            return 'https://karta.merkurymarket.pl';
            // return 'https://esklep.merkurymarket.pl';
        case 2:
            // return '';
            return 'https://esklep.merkurymarket.pl';
        case 3:
            return 'https://stage-karta.merkurymarket.pl';
            // return 'https://ekarty.merkurymarket.pl/api/';
    }
}

const AppTyp = () => {
    switch (typ) {
        case 1:
            return 'DEV';
        case 2:
            return 'PROD';
        case 3:
            return 'STAGE';
    }
}

export const topWersja = () => {
    if (isDesktop) {
        return AppVersion+'-'+AppData+'-WEB.DESKTOP-PL-'+AppTyp()
    } else if (isAndroid) {
        return AppVersion+'-'+AppData+'-WEB.ANDROID-PL-'+AppTyp()
    } else if (isIOS){
        return AppVersion+'-'+AppData+'-WEB.IOS-PL-'+AppTyp()
    } else {
        return AppVersion+'-'+AppData+'-WEB.INNE-PL-'+AppTyp()
    }
}

export const isLogged = () => {
    if (sessionStorage.isUserLoggedMM !== undefined && sessionStorage.isUserLoggedMM !== null){
        return true;
    } else {
        return false;
    }
}

export const getCurrentUser = () => {
    if (isLogged()) {
        let user: any = sessionStorage.getItem('isUserLoggedMM');
        return JSON.parse(user)
    } else return null
};

export const logOut = () => {
    sessionStorage.removeItem('isUserLoggedMM');
    window.location.replace('/')
}

export const isEmpty = (value: any) => {
    return (value === null) || (value === undefined) || (value === '');
}

export const validateNip = (nip: any) => {
    if (isNaN(nip[0])) {
        nip = nip.substring(2)
    }
    nip = nip.replace(/[\ \-]/gi, '');

    let weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
    let sum = 0;
    let controlNumber = parseInt(nip.substring(9, 10));
    let weightCount = weight.length;
    for (let i = 0; i < weightCount; i++) {
        sum += (parseInt(nip.substr(i, 1)) * weight[i]);
    }

    return sum % 11 === controlNumber;
}
